import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
    modal: {
        position: "absolute",
        background: "#535252",
        width: "80%",
        zIndex: 99,
        minHeight: "70%",
        overflow: "auto",
        padding: "20px",
        margin: "10%",
        maxHeight: 500
    },
    topModalBody: {
        position: "absolute",
        background: "#535252",
        width: "460px",
        zIndex: 100,
        height: "300px",
        overflow: "auto",
        marginLeft: "calc(50% - 230px)",
        marginTop: "calc(50vh - 150px)",
        padding: "20px 30px 20px 30px"
    },
    modalBodyTitle: {
        fontSize: 20,
        fontWeight: "bold",
        background: "#535252",
        height: "40px",
        lineHeight: "40px"
    },

    modalFooter: {
        background: "#535252",
    },
    containerGrid: {
        width: 'calc(100% - 10px)'
    },
    modalHeader: {
        height: "max-content",
        position: "relative",
        background: theme.palette.inPatient.formBackground,
        borderRadius: 10,
        padding: 20

    },
    modalTitle: {
        textAlign: "center",
        fontSize: 20,
        fontWeight: "bold"
    },
    backgroundModal : {
        position: "absolute",
        background: "black",
        top: 0,
        left: 0,
        width: "100%",
        height:  "100%",
        opacity: "0.7",
        zIndex: 99
    },
    backgroundModal2 : {
        position: "absolute",
        background: "black",
        top: 0,
        left: 0,
        width: "100%",
        height:  "100%",
        opacity: "0.7",
        zIndex: 100
    },
    selectorItemFormControl: {
        width: "30%"
    },
    selectorItemSelect: {
        width: "100%",
        fontSize: "80%",
        marginTop: "9px !important",
    },
    selectorItemLabel: {
        fontSize: "80%",
    },
    buttons: {
        position: "absolute",
        bottom: "20px;",
        width: "calc(100% - 40px)"
    },
    buttonNext: {
        float: "right",
        marginLeft: "6px"
    },
    input: {
        backgroundColor: theme.palette.mode === 'light' ? '#d2d5d9' : '#3D3E40',
        border: "1px solid #626466"
    },
    outcome: {
        border: "1px solid #003caf",
        background: "#cfdffd",
        padding: "10px",
        color: "#3F73D6",
        marginTop: "20px",
        borderRadius: "5px",
        marginBottom: "7px"
    },
    outcomeLabel: {
        fontWeight: "bold",
        fontSize: 15,
        color: "#3F73D6",
    },
    info: {
        border: "1px solid #7199E6",
        background: "#fdcfdf",
        padding: 10,
        color: "#d63f3f",
        marginTop: 20,
        marginBottom: 20
    },
    infoLabel: {
        fontWeight: "bold",
        fontSize: 15,
        color: "#d63f3f",
    },
    sheet: {
        height: "calc(100% - 72px - 20px - 20px - 25px - 40px)",
        maxHeight: "calc(100% - 72px - 20px - 20px - 25px - 40px)",
        position: "inherit",
        width: "calc(100% - 40px)",
        overflow: "auto",
        paddingRight: "15px"
    },
    questionLabel: {
        display: "inline-flex",
        paddingTop: "10px"
    },
    infoIcon: {
        width: "1.6em",
        height: "1.6em"
    },
    vmiddle: {
        verticalAlign: "middle",
        width: '100%',
    },
    inputlabel:{
        color: theme.palette.inPatient.questionText,
        fontSize: "12px",
        marginTop: "10px",
        marginBottom: "5px",
        marginLeft: "10px",
        fontWeight: 600
    },
    table: {
        minWidth: 650,
        borderCollapse: 'separate',
        borderSpacing: '0px 6px'
    },
    tableHeader: {
        backgroundColor: theme.palette.background.header,
        borderTopLeftRadius:'15px',
        borderBottomLeftRadius: '15px',
        borderBottomRightRadius: '15px',
        borderTopRightRadius: '15px',
        "& td": {
            border: 0
        },
        "& th": {
            border: 0
        }
        // borderRadius: '15px'
    },
    tableRow: {
        boxShadow: `0px ${theme.palette.mode === 'light' ? 2 : 0}px ${theme.palette.mode === 'light' ? 1 : 0}px 0px rgba(0, 0, 0, 0.25)`,
        backgroundColor: theme.palette.background.paperDarker,
        borderRadius: theme.palette.mode === 'light' ? 10 : 0,
        marginTop: "10px",
        "& td": {
            border: 0
        },
        "& th": {
            border: 0
        }
    },
    tableCell: {
        padding: 10
    },
    label: {
        color: theme.palette.mode === 'light' ? '#626466' : '#ACAFB3',
        fontWeight: 'bold',
        fontSize: 14,
        marginLeft: 2,
    },
    borderRadiusLeft: {
        borderTopLeftRadius: '10px',
        borderBottomLeftRadius: '10px',
        // overflow: 'hidden'
    },
    borderRadiusRight: {
        borderTopRightRadius: '10px',
        borderBottomRightRadius: '10px',
        // overflow: 'hidden'
    },
    tableResults: {
        padding: 10,
    },
    formControl: {
        width: '100%',
    },
    formControlDT: {
        width: '100%',
        margin: 0,
    },
    inlineFormBlock: {
        display: "inline-flex"
    },
    spaceLeft: {
        marginLeft: "12px"
    },
    consultedWith: {
        marginLeft: "100px",
        width: "560px",
        marginBottom: "15px"
    },
    consultedHeader: {
        textAlign: "left",
        paddingTop: "5px",
        paddingBottom: "5px",
        borderBottom: "1px solid silver"
    },
    consultedData: {
        textAlign: "left",
        paddingTop: "5px",
    },
    buttonInsert: {
        color: "white",
        background: "#28a745;"
    },
    buttonRemove: {
        color: "white",
        background: "#dc3545;"
    },
    answerBlock: {

    },
    theader: {
        fontWeight: "600"
    },
    textAnswer: {
        textAlign: "left",
        border: "1px solid #626466",
        borderRadius: "5px",
        padding: "11px 4px 7px 4px",
        width: "100%",
        background: theme.palette.inPatient.dncprAnswer,
        minHeight: "80px",
        marginTop: "10px",
        marginBottom: "6px"
    },
    labelInline: {
        display: "inline-flex"
    },
    textAnswerInline: {
        textAlign: "left",
        border: "1px solid #626466",
        borderRadius: "5px",
        padding: "7px 10px 7px 10px",
        background: "#3D3E40",
        display: "inline-flex",
        marginLeft: "5px",
        marginRight: "5px"
    },
    questionAnswer: {
        textAlign: "left",
        width: "100%",
        marginTop: "4px"
    },
    questionAnswerBlock: {
        textAlign: "center",
        border: "1px solid #626466",
        borderRadius: "5px",
        padding: "11px 4px 7px 4px",
        width: "120px",
        background: theme.palette.inPatient.dncprAnswer,
        float: "right"
    },
    title: {
        fontSize: "32px",
        fontWeight: "200"
    },
    subtitle: {
        fontSize: "smaller",
        fontWeight: "100",
        color: "silver",
        display: "inline"
    },
    dnacprContrSignBlock: {
        border: "1px solid #c37d7d",
        borderRadius: "5px",
        background: "#ffbaba",
        color: "darkred",
        padding: "5px 10px",
        lineHeight: "30px",
        marginBottom: "10px"
    },
    btnSign: {
        display: "inline",
        border: "1px solid #983434",
        padding: "4px 8px",
        color: "white",
        borderRadius: "5px",
        float: "right",
        lineHeight: "20px",
        background: "#ff4b4b",
        cursor: "pointer"
    },
    btnSignGreen: {
        display: "inline",
        border: "1px solid #318042",
        padding: "4px 8px",
        color: "white",
        borderRadius: "5px",
        float: "right",
        lineHeight: "20px",
        background: "#28A745",
        cursor: "pointer",
        marginLeft: "5px"
    },
    borderedHeader: {
        marginTop: "54px",
        marginBottom: "4px",
        paddingTop: "10px",
        paddingBottom: "10px",
        borderTop: "1px solid silver",
        borderBottom: "1px solid silver"
    },
    topButtons: {
        paddingTop: "10px",
        marginBottom: "10px",
        display: "flex",
        justifyContent: "flex-end"
    },
    button: {
        display: "inline-flex",
        minWidth: 105,
        marginRight: 10
    },
    formContainer: {
        background: theme.palette.inPatient.formBackground,
        borderRadius: 10,
        padding: "0 20px 20px 20px"
    },
    modalBody: {
        position: "relative",
        height: 'calc(100% - 170px)',
        overflow: "auto",
        paddingTop: 20,
        paddingBottom: 10,
    },
    topBar: {
        display: "flex",
        alignItems: "center",
        justifyContent: 'space-between',
        paddingBottom: 15,
        paddingTop: 10,
        position: "sticky",
        top: "0px",
        background: theme.palette.background.defaultBackground,
        zIndex: 11
    },
    flexDiv: {
        display: "flex",
        alignItems: "center",
        justifyContent: 'space-between',
    },
    formName: {
        fontSize: 16,
        fontWeight: 600
    }
}));